import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetBannerCarouselModel } from "@NA/Services/GetBannerCarousel";
import { Draft } from "immer";
import GetHomePageCarouselState from "../Data/ADIGetHomePageCarouselState";

const initialState: GetHomePageCarouselState = {
    isLoading: false,
};

const reducer = {
    "HomePage/GetHomePageCarousel": (draft: Draft<GetHomePageCarouselState>) => {
        draft.isLoading = true;
    },
    "Homepage/DispatchCompleteLoadHomePageCarousel": (
        draft: Draft<GetHomePageCarouselState>,
        action: { bannerCarousel: { result: GetBannerCarouselModel } },
    ) => {
        draft.isLoading = false;
        draft.bannerCarousel = action.bannerCarousel.result;
    },
    "HomePage/ClearHomePageCarousel": () => {
        return initialState;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
